import { RcThemeInput } from '@ringcentral/juno';
import { overridesFactory } from '@/shared/theme/utils/overrides.factory';
import { paletteFactory } from '@/shared/theme/utils/palette.factory';

export const atosColor = '#0066A1';

export const atosTheme: RcThemeInput = {
  palette: paletteFactory(atosColor),
  overrides: overridesFactory(atosColor),
};
